import React from 'react';
import { ReactComponentWrapper, dispatchReactComponentUpdate, } from './react-shape/common';
import ReactBaseEdge from './react-shape/base-edge';
import { MarkerType } from 'reactflow';
export var EDGE_PRIMARY_COLOR;
(function (EDGE_PRIMARY_COLOR) {
    EDGE_PRIMARY_COLOR["YELLOW"] = "rgb(255,207,86)1";
    EDGE_PRIMARY_COLOR["ORANGE"] = "rgb(246,105,3)";
    EDGE_PRIMARY_COLOR["PURPLE"] = "rgb(145,86,255)";
    EDGE_PRIMARY_COLOR["BLUE"] = "rgb(73,151,255)";
    EDGE_PRIMARY_COLOR["GREY"] = "rgb(170,170,170)";
})(EDGE_PRIMARY_COLOR || (EDGE_PRIMARY_COLOR = {}));
/** NodeClass */
export class BaseEdge {
    get oflowEdgeDom() {
        const { id } = this;
        return document.querySelector(`g[oflow-element-id='${id}']`);
    }
    get oflowEdgeId() {
        const { id } = this.config;
        return `${id}`;
    }
    get oflowLabelId() {
        const { id } = this.config;
        return `${id}`;
    }
    get sourceNodeInstance() {
        return this.canvasModel.getCanvasElementInstance(this.config.source);
    }
    get targetNodeInstance() {
        return this.canvasModel.getCanvasElementInstance(this.config.target);
    }
    constructor({ canvasId, model, config, }) {
        this.primaryColor = EDGE_PRIMARY_COLOR.GREY;
        this.couldDelete = true;
        this.couldCopy = true;
        this.sethighlight = (highlight) => {
            const previousValue = this.highlight;
            if (typeof highlight === 'boolean') {
                this.highlight = highlight;
            }
            else {
                this.highlight = highlight(this.highlight);
            }
            if (previousValue !== this.highlight) {
                this.reRender();
            }
        };
        this.configChangeQueue = [];
        this.onConfigChange = (fn) => {
            this.configChangeQueue.push(fn);
        };
        this.offConfigChange = (fn) => {
            var _a;
            const idx = (_a = this.configChangeQueue) === null || _a === void 0 ? void 0 : _a.findIndex(item => item === fn);
            this.configChangeQueue.splice(idx, 1);
        };
        this.getConfig = () => {
            return Object.assign(Object.assign({}, this.config), { sourceHandle: this.config.sourceHandle || this.config.sourceHandleId, targetHandle: this.config.targetHandle || this.config.targetHandleId });
        };
        this.canvasId = canvasId;
        this.model = model;
        this.canvasModel = model.getCanvasModel(canvasId);
        this.config = config;
        this.id = config.id;
        this.canvasModel.bindCanvasElement(this.id, this);
        // @ts-ignore
        const defaultConfig = this.constructor.defaultConfig;
        this.setConfig(config => {
            return Object.assign(Object.assign({}, defaultConfig), config);
        });
    }
    // 设置
    setConfig(params) {
        var _a;
        let newConfig;
        if (typeof params === 'function') {
            newConfig = params(this.config);
        }
        else {
            newConfig = params;
        }
        this.config = newConfig;
        (_a = this.configChangeQueue) === null || _a === void 0 ? void 0 : _a.forEach(changeFn => {
            changeFn(this.config);
        });
    }
    reRender() {
        const { highlight, config } = this;
        dispatchReactComponentUpdate(this, Object.assign(Object.assign({}, config), { highlight }));
    }
}
BaseEdge.defaultConfig = {
    shapeType: 'SmoothStep',
    animated: false,
};
BaseEdge.ReactComponent = ReactBaseEdge;
BaseEdge.defaultShapeInfo = {
    markerEnd: MarkerType.ArrowClosed,
};
BaseEdge.Render = ({ instance, shapeInfo }) => {
    return React.createElement(ReactComponentWrapper, { instance: instance, key: instance.id, shapeInfo: shapeInfo });
};
//# sourceMappingURL=common.js.map